import { Skeleton, SxProps, Theme } from '@mui/material';

export const FeaturedProductSkeleton = ({ sx }: { sx?: SxProps<Theme> }) => (
	<Skeleton variant="rounded" height={539} sx={sx} />
);
